<template>
    <div class="modal" :style="{ width: width, height: height, marginLeft: marginLeft }">
        <div class="text">
            본 서비스는 PC에서<br/>
            사용 가능합니다.
        </div>
        <div class="close" @click="$emit('close')">
            닫기
        </div>
    </div>
</template>

<script>
import mobileDetect from 'mobile-detect'

export default {
    props: ['user-device'],
    data() {
        return {
            width: 0,
            height: 0,
            marginLeft: 0
        }
    },
    created() {
        const resize = () => {
            if (this.userDevice === 'pc') {
                if (Math.abs(window.orientation) === 90) {
                    this.width = window.innerWidth * 0.5 + 'px'
                    this.height = window.innerHeight * 0.6 + 'px'
                    this.marginLeft = 0
                } else {
                    this.width = window.innerWidth * 0.7 + 'px'
                    this.height = window.innerHeight * 0.3 + 'px'
                    this.marginLeft = `calc(50% - ${this.width} / 2)`;
                }
            } else if (window.innerWidth < 420) {
                this.width = '80vw';
                this.marginLeft = '10vw'
                this.height = null;
            } else {
                this.width = null;
                this.height = null;
            }
        }
        resize();
        window.addEventListener('resize', resize);
    }
}
</script>

<style scoped>
    @import url(./modal);

    .modal {
        z-index: 1000;
    }

    .text {
        font-size: 14px;
    }

    .close {
        font-size: 12px;
        width: 100px;
        height: 40px;
        line-height: 40px;
        margin-top: -10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/runner/Modal4.vue